export const ctaTypes = {
  undef: 'UNDEF',
  quote: 'QUOTE',
  rental: 'RENTAL',
  review: 'REVIEW',
  complete: 'COMPLETE',
};
